export default __webpack_public_path__ + "static/media/counterStrike.2740e5ff.jpeg";